import { createFileRoute, redirect } from '@tanstack/react-router';

import { UserRoles } from '~entities/users';
import { EmailBuilderPage } from '~pages/email-builder';
import { checkMinRoleValue } from '~shared/utils/role-guard';

function RouteComponent() {
  return <EmailBuilderPage />;
}

export const Route = createFileRoute('/_auth/_layout/email-builder')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  component: RouteComponent,
});
